<script>
	export let min = 0;
	export let max = 100;
	export let value = 0;
	export let color = "#638ec655";
	export let width = 45;
	export let height = 20;
	
	$: barWidth = width / max * Math.min(Math.max(value, min), max);
</script>

<div style="width: {width}px; height: {height}px">
	<div style="width: {barWidth}px; height: {height}px; background-color: {color}" />
</div>
